/* eslint-disable */
import React, { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { IPaginationPayload } from '../../../interfaces/shared/IPaginationPayload';
import { IToast } from '../../../interfaces/components/IToast';
import Toast from '../../../shared/toast';
import { IRequest } from '../../../interfaces/demo-requests/IRequest';
import { tryToEditDemoRequestStatus, tryToFetchDemoRequests } from '../../../store/brokers/partners/demo-requests/requestsSlice';
import DemoRequestsTable from './tables/DemoRequestsTable';
import Input from '../../../shared/input';
import Button from '../../../shared/button';
import InviteModal from './modals/InviteModal';

const DemoRequests = () => {
    const dispatch = useAppDispatch();
    const [requests, setRequests] = useState<IRequest[]>();
    const [search, setSearch] = useState<string>();
    const [statusFilter, setStatusFilter] = useState<string>('');
    const [dateFilter, setDateFilter] = useState<string>('');
    const [paginationState, setPaginationState] = useState<IPaginationPayload>({
        pageNumber: 1,
        pageSize: 10,
    });
    const [showToast, setShowToast] = useState<IToast | null>();
    const [showInviteModal, setShowInviteModal] = useState<boolean>(false)
    const paginationData = useAppSelector((state) => state.demoRequests?.requests?.data?.page);
    const loading = useAppSelector((state) => state.demoRequests?.requestsAreLoading);
    const state = useAppSelector((state) => state.demoRequests);

    useEffect(() => {
        if (state?.requests?.data?.elements) {
            setRequests(state?.requests?.data?.elements)
        }
    }, [state])

    const getRequestsData = async () => {
        try {
            let data: any = {
                ...paginationState || {},
            };
            if (search) {
                data = {
                    ...data,
                    filters: search,
                };
            }

            if (statusFilter) {
                data = {
                    ...data,
                    data: {
                        status: statusFilter
                    }
                };
            }
            if (dateFilter) {
                data = {
                    ...data,
                    data: {
                        date: dateFilter
                    }
                };
            }
            await dispatch(tryToFetchDemoRequests(data)).unwrap();
        } catch (err) {
            console.error(err, 'error')
        }
    }

    useEffect(() => {
        getRequestsData()
    }, [paginationState])

    const onSaveChanges = (type: string, message: string) => {
        setShowToast({ type: type, message: message })
        onResetPaginationState()
    }

    const onChangeState = async (id: string, status: string) => {
        try {
            await dispatch(tryToEditDemoRequestStatus({ id, status })).unwrap();
            onSaveChanges('success', 'Status changed successfully')
        } catch (err) {
            onSaveChanges('error', `${err}`)
        }
    }

    const onResetPaginationState = () => {
        setPaginationState({
            pageNumber: 1,
            pageSize: paginationState?.pageSize || 10,
        })
    }

    const onChangeSearch = (value: any) => {
        setSearch(value);
        onResetPaginationState();
    }

    const onClickClearFilters = () => {
        setSearch(undefined)
        setStatusFilter('')
        setDateFilter('')
        onResetPaginationState()
    }

    const onChangeStatusFilter = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setStatusFilter(e.target.value);
        onResetPaginationState();
    }

    const onChangeDateFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDateFilter(e.target.value);
        onResetPaginationState();
    }

    return (
        <div>
            <p className='text-xl mb-5 font-bold dark:text-primary-dark'>Early Access</p>

            <div className='my-5 flex flex-row justify-end'>
                <Button
                    label={'New Invite'}
                    className='btn-primary-rounded-less !min-w-[200px]'
                    onClickButton={() => setShowInviteModal(true)}
                />
            </div>

            <div className='grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 mb-4'>
                <div>
                    <Input
                        placeholder='Search by email, company name or status'
                        showValue={true}
                        inputValue={search}
                        inputUniqueName='search'
                        containerStyle=''
                        onChangeInput={onChangeSearch}
                    />
                </div>

                <div className='relative'>
                    <label htmlFor='statusFilter' className='sr-only'>Status</label>
                    <select
                        id='statusFilter'
                        value={statusFilter}
                        onChange={onChangeStatusFilter}
                        className={[
                            'w-full rounded-md border border-gray-300 dark:border-gray-700',
                            'px-3 py-2 pr-9',
                            'text-sm outline-none',
                            'leading-[1.25rem]',
                            'bg-white text-gray-900',
                            'focus:ring-2 focus:ring-primary focus:border-transparent',
                            'dark:bg-black dark:text-white',
                            'appearance-none',
                        ].join(' ')}
                    >

                        <option value=''>All statuses</option>
                        <option value='ACCEPTED'>Accepted</option>
                        <option value='REJECTED'>Rejected</option>
                        {/* <option value='NO_STATUS'>No Status</option> */}
                    </select>
                    {/* Chevron */}
                    <div className='pointer-events-none absolute inset-y-0 right-2 flex items-center'>
                        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='currentColor' className='h-4 w-4 mb-8 text-gray-500 dark:text-gray-300'>
                            <path fillRule='evenodd' d='M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z' clipRule='evenodd' />
                        </svg>
                    </div>
                </div>


                {/* Date Picker */}
                <div>
                    <label htmlFor='dateFilter' className='sr-only'>Date</label>
                    <input
                        id='dateFilter'
                        type='date'
                        value={dateFilter}
                        onChange={onChangeDateFilter}
                        className={[
                            'w-full rounded-md border border-gray-300 dark:border-gray-700',
                            'px-3 py-2 text-sm outline-none',
                            'bg-white text-gray-900',
                            'focus:ring-2 focus:ring-primary focus:border-transparent',
                            'dark:bg-black dark:text-white'
                        ].join(' ')}
                    />
                </div>
            </div>
            <div className='my-2 flex flex-row justify-end'>
                <div onClick={onClickClearFilters} className='text-primary-light cursor-pointer hover:opacity-80'>
                    <p className='underline'>Clear All Filters</p>
                </div>
            </div>
            <div>
                <DemoRequestsTable
                    rows={requests}
                    loading={loading}
                    paginationData={paginationData}
                    paginationState={paginationState}
                    setPaginationState={setPaginationState}
                    onChangeStatus={onChangeState}
                />
            </div>
            {showToast?.message &&
                <Toast
                    type={showToast?.type}
                    text={showToast?.message}
                    onHandleCloseToast={() => setShowToast(null)}
                />
            }
            {showInviteModal &&
                <InviteModal
                    openModal={showInviteModal}
                    handleCloseModal={() => setShowInviteModal(false)}
                    onSaveChanges={onSaveChanges}
                />
            }
        </div>
    )
}
export default DemoRequests;